<template>
  <v-sheet height="200px">
    <v-layout justify-center="justify-center">
      <div class="text-center" :style="bottomSheetWidth">
        <div class="d-flex">
          <v-btn
            class="mt-4"
            text="text"
            large="large"
            color="grey darken-2"
            @click="onCancelAction"
            >{{ cancelActionTextComputed }}</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn
            class="mt-4"
            text="text"
            large="large"
            :color="confirmActionColorComputed"
            @click="onConfirmAction"
            >{{ confirmActionTextComputed }}</v-btn
          >
        </div>
        <div class="pa-3">
          <h3 class="font-weight-regular">{{ textComputed }}</h3>
        </div>
      </div>
    </v-layout>
  </v-sheet>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: "app-alert",
  props: ["options"],

  data() {
    return {
      text: "",
      cancelAction: {},
      confirmAction: {},
      t: null,
    };
  },

  mounted() {
    this.handleOptions(this.options);
  },

  computed: {
    bottomSheetWidth() {
      switch (this.$vuetify.breakpoint.name) {
        case "lg":
          return "width: 650px;";
        default:
          return "width: 550px;";
      }
    },
    cancelActionTextComputed() {
      return this.cancelAction.t
        ? this.$t(this.cancelAction.t)
        : this.cancelAction.text;
    },
    confirmActionTextComputed() {
      return this.confirmAction.t
        ? this.$t(this.confirmAction.t)
        : this.confirmAction.text;
    },
    confirmActionColorComputed() {
      return this.confirmAction.color ?? "primary";
    },
    textComputed() {
      return this.t ? this.$t(this.t) : this.text;
    },
  },

  watch: {
    options(v) {
      this.handleOptions(v);
    },
  },

  methods: {
    handleOptions(v) {
      if (v?.actions?.length) {
        const [cancel, confirm] = v.actions;
        this.confirmAction = confirm ?? cancel ?? { t: "alert.button.confirm" };
        const cnc = confirm && cancel;
        this.cancelAction = cnc ? cancel : { t: "alert.button.cancel" };
      }
      this.text = v?.text;
      this.t = v?.t;
    },

    onCancelAction() {
      this.cancelAction?.onPress?.();
      this.$nextTick(() => {
        this.$alert.dismiss();
      });
    },

    onConfirmAction() {
      this.confirmAction?.onPress?.();
      this.$nextTick(() => {
        this.$alert.dismiss();
      });
    },
  },
});
</script>
